<template>
    <DashboardContainer>
        <EditDealer></EditDealer>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../../containers/DashboardContainer'
import EditDealer from '../../components/admin/dealers/editDealer'
export default {
    // name:'Dealers',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        EditDealer
    }
}
</script>